import styled from 'styled-components';
import { Breakpoints } from '../../../../styled/constants';
import { Typography } from '../../../ui/Typography';
import {
  ellipsisText,
  FlexBetween,
  FlexibleDiv
} from '../../../../styled/common';

export const ResidenceGalleryHeaderContainer = styled(FlexBetween)`
  width: 100%;
  height: 45px;
  position: relative;

  @media screen and (min-width: ${Breakpoints.smallDesktop}px) {
    padding: 10px 30px;
    height: 70px;
    gap: 20px;
    background-color: #191919;
  }
`;

export const CloseButton = styled(FlexibleDiv)`
  padding: 0 15px;
  height: 100%;
  width: 100px;
  cursor: pointer;
  align-items: center;

  @media screen and (min-width: ${Breakpoints.smallDesktop}px) {
    width: 40px;
    height: 40px;
    padding: 0;
    justify-content: center;
  }
`;

export const GalleryInfo = styled(Typography)`
  color: ${({ theme }) => theme.colors.text.white};
  position: absolute;
  left: 50%;
  transform: translateX(-50%);

  @media screen and (min-width: ${Breakpoints.smallDesktop}px) {
    display: none;
  }
`;

export const GalleryHeaderContent = styled(FlexibleDiv)`
  display: none;

  @media screen and (min-width: ${Breakpoints.smallDesktop}px) {
    display: flex;
    gap: 15px;
    flex: 1 1 auto;
    min-width: 0;
    align-items: center;
  }

  @media screen and (min-width: ${Breakpoints.desktop}px) {
    gap: 20px;
  }
`;

export const ContentText = styled(Typography)`
  color: ${({ theme }) => theme.colors.background.primary};
`;

export const Divider = styled.div`
  width: 1px;
  height: 22px;
  background-color: rgb(250, 250, 250, 0.25);
`;

export const DescriptionText = styled(ContentText)`
  ${ellipsisText}
`;

export const BuildingInfoText = styled(ContentText)`
  white-space: nowrap;
`;

export const PhoneWrapper = styled.div`
  display: none;

  @media screen and (min-width: ${Breakpoints.smallDesktop}px) {
    display: block;
  }
`;

export const LeftActionsContainer = styled(FlexibleDiv)`
  height: 100%;
  gap: 20px;
  flex: 0 0 auto;
  align-items: center;

  @media screen and (min-width: ${Breakpoints.desktop}px) {
    gap: 30px;
  }
`;
